import * as t from "./actionType";

const initialState = {
  list: [],
  listLoading: false,
  listByCustomer: [],
  listByCustomerLoading: false,
  data: [],
  dataLoading: false,
  create: [],
  createLoading: false,
  update: [],
  updateLoading: false,
  remove: [],
  removeLoading: false,
};

const CallInbound = (state = initialState, action) => {
  switch (action.type) {
    case t.CALL_INBOUND_LIST:
      return { ...state, listLoading: true };
    case t.CALL_INBOUND_LIST_SUCCESS:
      return { ...state, list: action.data, listLoading: false };
    case t.CALL_INBOUND_LIST_FAIL:
      return { ...state, listLoading: false };

    case t.CALL_INBOUND_LIST_BY_CUSTOMER:
      return { ...state, listByCustomerLoading: true };
    case t.CALL_INBOUND_LIST_BY_CUSTOMER_SUCCESS:
      return { ...state, listByCustomer: action.data, listByCustomerLoading: false };
    case t.CALL_INBOUND_LIST_BY_CUSTOMER_FAIL:
      return { ...state, listByCustomerLoading: false };

    case t.CALL_INBOUND_DATA:
      return { ...state, dataLoading: true };
    case t.CALL_INBOUND_DATA_SUCCESS:
      return { ...state, data: action.data, dataLoading: false };
    case t.CALL_INBOUND_DATA_FAIL:
      return { ...state, dataLoading: false };

    case t.CALL_INBOUND_CREATE:
      return { ...state, createLoading: true };
    case t.CALL_INBOUND_CREATE_SUCCESS:
      return { ...state, create: action.data, createLoading: false };
    case t.CALL_INBOUND_CREATE_FAIL:
      return { ...state, createLoading: false };
    case t.CALL_INBOUND_CREATE_RESET:
      return { ...state, create: [] };

    case t.CALL_INBOUND_UPDATE:
      return { ...state, updateLoading: true };
    case t.CALL_INBOUND_UPDATE_SUCCESS:
      return { ...state, update: action.data, updateLoading: false };
    case t.CALL_INBOUND_UPDATE_FAIL:
      return { ...state, updateLoading: false };
    case t.CALL_INBOUND_UPDATE_RESET:
      return { ...state, update: [] };

    case t.CALL_INBOUND_DELETE:
      return { ...state, removeLoading: true };
    case t.CALL_INBOUND_DELETE_SUCCESS:
      return { ...state, remove: action.data, removeLoading: false };
    case t.CALL_INBOUND_DELETE_FAIL:
      return { ...state, removeLoading: false };
    case t.CALL_INBOUND_DELETE_RESET:
      return { ...state, remove: [] };

    default:
      return state;
  }
};

export default CallInbound;
